<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="headline font-weight-bold mb-4">
            PopUp de nuevos lanzamientos
          </div>
          <v-breadcrumbs
            divider=">"
            :items="breadcrumbItems"
            class="pa-0"
          ></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text class="d-flex justify-space-between">
              <span class="title">
                Configurar popup de Nuevos Lanzamientos
              </span>
              <v-btn
                color="primary"
                icon
                @click="togglePopUpDialogConfig(true)"
              >
                <v-icon>
                  tune
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <NewReleasePopUpConfig />
    </v-container>
  </template>
  
  <script>
  
  import { organizationService } from '@/services/organization.service'
  import { mapActions, mapState } from 'vuex'
  import NewReleasePopUpConfig from '@/components/Comunications/NewReleasePopUpConfig.vue'
  
  export default {
    name: 'PopUp',
    components: {
      NewReleasePopUpConfig
    },
    data () {
      return {
        breadcrumbItems: [
          {
            text: 'Comunicaciones',
            disabled: false
          },
          {
            text: 'Configurar pop up de nuevos lanzamientos',
            disabled: true,
            href: ''
          }
        ],
        isOpenDialogConfig: false,
        display: false,
        dialogTranslations: [],
        dialogConfig: {
          language_code: null,
          is_default: false,
          title: null,
          content: null,
          confirm: null
        }
      }
    },
    computed: {
      ...mapState({
        languages: ({ auth: { locales } }) => locales
      })
    },
 
    methods: {
      ...mapActions({
        togglePopUpDialogConfig: 'newReleasePopup/togglePopUpDialogConfig'
      }),
      async updateNotificationGeneral () {
        try {
          this.loading = true
          await organizationService.updateGeneralNotificationConfig({
            ...this.dialogConfig
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      
    }
  }
  </script>
  